import { render, staticRenderFns } from "./AddLessonToUserModal.vue?vue&type=template&id=1c8f963c"
import script from "./AddLessonToUserModal.vue?vue&type=script&lang=js"
export * from "./AddLessonToUserModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports